<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 12:42:04
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-09 11:37:03
 * @FilePath: \jsczt\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      height: ''
    }
  },
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  },
  mounted () {
    window.addEventListener('load', this.handleResize)
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.height = window.outerHeight + 'px'
    }
  }
}
</script>

<style>
body{
  margin: 0px;
  padding: 0px;
}
#app {
  margin: 0;
  padding: 0;
  height: 100vh;
  background: #f2f5f7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue